import Mouse from './Mouse';
export default Mouse;
